import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { ITimeOffReportSettings } from 'types/TimeOffReportSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useTimeOffReportSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof ITimeOffReportSettings>(keysAndPayloads: { key: K; payload: ITimeOffReportSettings[K] }[]) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.timeOffReport);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('timeOffReport', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
